import { render, staticRenderFns } from "./ItemsOrderServiceCreateUpdate.vue?vue&type=template&id=119ccdda&scoped=true&"
import script from "./ItemsOrderServiceCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./ItemsOrderServiceCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ItemsOrderServiceCreateUpdate.vue?vue&type=style&index=0&id=119ccdda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119ccdda",
  null
  
)

export default component.exports